import { isClientSide } from './generic-functions';

interface MixpanelScreenViewedEventProps {
  path: string;
  from: string;
}

interface MixpanelEvent<T> {
  eventName: string;
  props: T;
}

interface MixpanelSuperProps {
  application?: string;
}

export interface MixpanelContentLessonCardClick {
  lesson: string;
  lesson_name: string;
  lesson_id: string;
  lesson_type: string;
  course: string;
  course_name: string;
  course_id: string;
  level_1: string;
  level_name_1: string;
  level_2?: string;
  level_name_2?: string;
  level_3?: string;
  level_name_3?: string;
  teacher?: string;
  student_id?: string;
  user?: string;
  email?: string;
}

export class Tracking {
  private static mixpanelOptions = { useMixpanel: true, useHubspot: false };

  public static registerSuperProps(props: MixpanelSuperProps): void {
    const propsToSend = props.application ? props : {};

    POCKET.registerMixpanel(propsToSend);
  }

  public static pageView(): void {
    if (!isClientSide()) return;
    this.trackEvent<MixpanelEvent<MixpanelScreenViewedEventProps>>({
      eventName: 'Page View',
      props: {
        path: location.pathname,
        from: 'descomplica-io-lms',
      },
    });
  }

  private static trackEvent<T>(event: T): void {
    if (!isClientSide()) return;
    const e = event as unknown as MixpanelEvent<any>;
    POCKET.track(
      e.eventName,
      {
        ...e.props,
      },
      Tracking.mixpanelOptions,
    );
  }

  public static contentLessonCardClick(
    contentLessonCardClickEvent: MixpanelContentLessonCardClick,
  ): void {
    if (!isClientSide()) return;
    this.trackEvent<MixpanelEvent<MixpanelContentLessonCardClick>>({
      eventName: 'ContentLessonCard Clicked',
      props: contentLessonCardClickEvent,
    });
  }
}
